import { useCallback } from 'react';

import { startOfDay } from 'date-fns/startOfDay';

import { GeographyTypeEnum } from '@nocowanie/core/enums';

import { getLegacyListingUrl } from '@app/helpers/legacy-url-mapping.helpers';
import { useMapSearch } from '@app/hooks/useMapSearch';

import { useSsrListingRedirect } from './useSsrListingRedirect';

export function useMapBackNavigation() {
    const { searchCriteria, filters, locationDetails } = useMapSearch();
    const { tryRedirectToSsrListing } = useSsrListingRedirect();

    const navigateToListing = useCallback(() => {
        const currentLocationData =
            // add another geography types to the array once they're switched to SSR listings
            locationDetails?.type && [GeographyTypeEnum.city].includes(locationDetails.type)
                ? {
                      id: `${locationDetails.type}/${searchCriteria.geoId}`,
                      path: locationDetails.path ?? '/',
                      type: locationDetails.type,
                      name: locationDetails.name,
                      caption: '',
                  }
                : null;

        const finalData = {
            location: searchCriteria.location,
            dates: {
                checkInDate: searchCriteria.checkInDate
                    ? startOfDay(new Date(searchCriteria.checkInDate))
                    : null,
                checkOutDate: searchCriteria.checkOutDate
                    ? startOfDay(new Date(searchCriteria.checkOutDate))
                    : null,
            },
            guests: {
                adultsCount: searchCriteria.guests.adultsCount,
                childrenCount: searchCriteria.guests.childrenCount,
                childrenAges: searchCriteria.guests.childrenAges,
            },
            geoId: searchCriteria.geoId ?? undefined,
            flexDates: searchCriteria.flexDates,
        };

        if (
            tryRedirectToSsrListing({
                selectedItem: currentLocationData,
                finalData,
                filters,
            })
        ) {
            return true;
        }

        //  fallback to legacy listings
        const legacyUrl = getLegacyListingUrl(searchCriteria, filters, locationDetails);
        window.location.href = legacyUrl;
    }, [searchCriteria, filters, locationDetails]);

    return {
        navigateToListing,
    };
}
